import * as React from "react";
import { Spinner } from "../Common/Spinner";

export const LoadingScreen = () => (
  <div className="flex-fill d-flex flex-column justify-content-center align-items-center">
    <Spinner />
  </div>
);
